import React from 'react'
import './InputParametersHierarchyInfo.scss'

interface InputParametersHierarchyInfoProps {
  icon: string
  message: string
}

export const InputParametersHierarchyInfo: React.FC<InputParametersHierarchyInfoProps> = ({ icon, message }) => {
  return (
    <div className='d-flex p-2 my-3 zocks-bg-color-primary-light ip-hierarchy-info'>
      <div className='d-flex gap-2 align-items-center'>
        <i className={`bi ${icon} zocks-text-primary`} />
        <div className='paragraph-medium-extended'>{message}</div>
      </div>
    </div>
  )
}
